export default __webpack_public_path__ + "dd5e5b90ca8ee986b13b04310f9aef9d.ttf";